import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Sarah Mitchell',
    location: 'Manchester',
    rating: 5,
    text: 'Our washing machine broke down on a Sunday evening. Called Caringhand first thing Monday and they had an engineer out by Tuesday afternoon. Fixed the same day. Brilliant service.',
    appliance: 'Washing Machine'
  }, {
    name: 'David Thompson',
    location: 'Liverpool',
    rating: 5,
    text: 'Very professional and polite engineer. Explained everything clearly and the repair was done quickly. Pricing was transparent with no surprises. Would definitely use again.',
    appliance: 'Dishwasher'
  }, {
    name: 'Emma Roberts',
    location: 'Leeds',
    rating: 5,
    text: 'Excellent service from start to finish. The engineer arrived on time, diagnosed the problem with our fridge, and had it working again within an hour. Very impressed.',
    appliance: 'Fridge/Freezer'
  }];
  return <section className="py-16 bg-white" data-id="element-351">
      <div className="max-w-7xl mx-auto px-4" data-id="element-352">
        <div className="text-center mb-12" data-id="element-353">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-354">
            What Our Customers Say
          </h2>
          <p className="text-lg text-gray-600" data-id="element-355">
            Real feedback from real customers across the UK
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-356">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gray-50 p-8 rounded-xl shadow-sm" data-id="element-357">
              <div className="flex gap-1 mb-4" data-id="element-358">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="text-yellow-400 fill-current" size={20} data-id="element-359" />)}
              </div>
              <p className="text-gray-700 leading-relaxed mb-6 italic" data-id="element-360">
                "{testimonial.text}"
              </p>
              <div className="border-t border-gray-200 pt-4" data-id="element-361">
                <p className="font-semibold text-gray-900" data-id="element-362">
                  {testimonial.name}
                </p>
                <p className="text-sm text-gray-600" data-id="element-363">{testimonial.location}</p>
                <p className="text-xs text-gray-500 mt-1" data-id="element-364">
                  {testimonial.appliance}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}